'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { CategoryActions } from '@/components/shared/category-actions';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Bookmark02Icon, Bookmark02IconSolid, FilterVerticalIconSolid } from '@/components/ui/icon/glyphs';
import { cn } from '@/lib/ui/utils';
export interface ListingDiscoveryControlsProps {
  filterOpen: boolean;
  onFilterClick: () => void;
  watchlistActive: boolean;
  onWatchlistClick: () => void;
}
interface ListingDiscoveryActionsProps extends ListingDiscoveryControlsProps {
  creationAction: React.ReactNode;
  children: React.ReactNode;
}
export function ListingDiscoveryActions(t0) {
  const $ = _c(22);
  let children;
  let controls;
  let creationAction;
  if ($[0] !== t0) {
    ({
      creationAction,
      children,
      ...controls
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = controls;
    $[3] = creationAction;
  } else {
    children = $[1];
    controls = $[2];
    creationAction = $[3];
  }
  let t1;
  let t2;
  if ($[4] !== controls) {
    t1 = <WatchlistButton {...controls} showLabel={true} />;
    t2 = <FilterButton {...controls} showLabel={true} />;
    $[4] = controls;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  let t3;
  if ($[7] !== creationAction || $[8] !== t1 || $[9] !== t2) {
    t3 = <CategoryActions>{t1}{t2}{creationAction}</CategoryActions>;
    $[7] = creationAction;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== controls) {
    t4 = <div className="lg:hidden"><FilterButton {...controls} /></div>;
    $[11] = controls;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== controls) {
    t5 = <div className="lg:hidden"><WatchlistButton {...controls} /></div>;
    $[13] = controls;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== children || $[16] !== t4 || $[17] !== t5) {
    t6 = <div className="flex shrink-0 items-center gap-0">{t4}{children}{t5}</div>;
    $[15] = children;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t3 || $[20] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[19] = t3;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function FilterButton(t0) {
  const $ = _c(13);
  const {
    filterOpen,
    onFilterClick,
    showLabel: t1
  } = t0;
  const showLabel = t1 === undefined ? false : t1;
  const t = useTranslations("markets");
  let t2;
  if ($[0] !== t) {
    t2 = t("filterButton");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = filterOpen && "bg-background-tertiary";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("text-foreground-tertiary hover:bg-background-tertiary", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== showLabel || $[5] !== t) {
    t5 = showLabel ? t("filterButton") : undefined;
    $[4] = showLabel;
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== filterOpen || $[8] !== onFilterClick || $[9] !== t2 || $[10] !== t4 || $[11] !== t5) {
    t6 = <AnimatedButton variant="tertiary" size="default" prefix={FilterVerticalIconSolid} onClick={onFilterClick} aria-label={t2} aria-haspopup="dialog" aria-expanded={filterOpen} className={t4}>{t5}</AnimatedButton>;
    $[7] = filterOpen;
    $[8] = onFilterClick;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
function WatchlistButton(t0) {
  const $ = _c(14);
  const {
    watchlistActive,
    onWatchlistClick,
    showLabel: t1
  } = t0;
  const showLabel = t1 === undefined ? false : t1;
  const t = useTranslations("markets");
  const t2 = watchlistActive ? Bookmark02IconSolid : Bookmark02Icon;
  let t3;
  if ($[0] !== t) {
    t3 = t("watchlist");
    $[0] = t;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = watchlistActive && "bg-background-tertiary";
  let t5;
  if ($[2] !== t4) {
    t5 = cn("text-foreground-tertiary hover:bg-background-tertiary", t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== showLabel || $[5] !== t) {
    t6 = showLabel ? t("watchlist") : undefined;
    $[4] = showLabel;
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== onWatchlistClick || $[8] !== t2 || $[9] !== t3 || $[10] !== t5 || $[11] !== t6 || $[12] !== watchlistActive) {
    t7 = <AnimatedButton variant="tertiary" size="default" prefix={t2} onClick={onWatchlistClick} aria-label={t3} aria-pressed={watchlistActive} className={t5}>{t6}</AnimatedButton>;
    $[7] = onWatchlistClick;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
    $[12] = watchlistActive;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}